// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"360":"219cad13","574":"04f4a823"}[chunkId] + ".chunk.css";
};